import { render } from "./EditorCard.vue?vue&type=template&id=5b200521&scoped=true"
import script from "./EditorCard.vue?vue&type=script&lang=js"
export * from "./EditorCard.vue?vue&type=script&lang=js"

import "./EditorCard.vue?vue&type=style&index=0&id=5b200521&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b200521"]])

export default __exports__